import { render, staticRenderFns } from "./EstDes1.vue?vue&type=template&id=2550d184&scoped=true&"
import script from "./EstDes1.vue?vue&type=script&lang=js&"
export * from "./EstDes1.vue?vue&type=script&lang=js&"
import style0 from "./EstDes1.vue?vue&type=style&index=0&id=2550d184&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2550d184",
  null
  
)

export default component.exports